<script>
import CommonService from "../services/common";
import kendo from "@progress/kendo-ui";
import Vue from "vue";


export default {
    name: "Base",
    mixins: [CommonService],
    data() {
        return {
            url: {
                list: "",
                edit: "",
                update: "",
                add: "",
                init: "",
                delete: "",
                redirect: ""
            },
            kendoGrid: null,
            vModel: {},
            isProcessing: false,
            extrafilter: false,
            externalFilterViewModel: {},
            pageable: {
                refresh: true,
                pageSizes: [20, 50, 100],
                buttonCount: 5
            },
            noRecords: true,
            messages: {
                noRecords: "There is no data on current page"
            },

            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: "contains",
                        startswith: "Starts with",
                        eq: "Is equal to",
                        neq: "Is not equal to"
                    },
                    date: {
                        gte: "From Date",
                        lte: "To Date"
                    },
                    customstring: {
                        contains: "contains"
                    }
                }
            },
            kendoDataSource: {
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 10,
                schema: {
                    data: "Data",
                    total: "Total"
                },
                transport: {
                    read: {
                        url: this.setUrl,
                        contentType: "application/json; charset=UTF-8",
                        type: "POST",
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader("DeviceType", "WebApp");
                            xhr.setRequestHeader("DeviceKey", CommonService.getAuthToken());
                        }
                    },
                    parameterMap: function (data, operation) {
                        if (kendo.ExternalFilter !== undefined)
                            data.ExternalFilter = kendo.ExternalFilter;
                        return JSON.stringify(data);
                    }
                },
                error: function (xhr) {

                    if (xhr.xhr.status == "401") {
                        CommonService.logOut(true);
                    } else {
                        var response = xhr.xhr;
                        var message = "";
                        if (response.responseText) {
                            var errorParse = JSON.parse(response.responseText);
                            if (errorParse.length && errorParse[0].Message) {
                                message = errorParse[0].Message
                            } else {
                                message = "Internal Sever Error";
                            }
                        }else{
                          message = "Internal Sever Error";
                        }                      

                        window.Vue.$toastr("error", message);
                    };

                },
                requestStart: function (e) {
                    Vue.prototype.$Progress.start();
                },
                requestEnd: function (e) {
                    Vue.prototype.$Progress.finish();
                }
            }
        };
    },
    props: ["id", "mode"],
    methods: {
        onEdit(event) {
            this.$router.push("/" + this.url.edit + "/" + event.target.dataset.item);
        },
        onDelete(event) {
            var self = this;
            if (self.isProcessing) return;
            kendo.confirm("Are you sure that you want to proceed?").then(function () {
                self.isProcessing = true;
                self.$http.get(self.url.delete + "/" + event.target.dataset.item).then(
                    response => {
                        self.isProcessing = false;
                        self.$toastr("success", "Deleted Successfully");
                        self.refreshKendoDataSource();
                    },
                    error => {
                        self.isProcessing = false;
                    }
                );
            });
        },

        onSubmit() {
            var self = this;
            if (self.isProcessing) return;

            self.$validator.validateAll().then(result => {
                if (result && this.beforeSave()) {
                    var url = self.id === undefined ? self.url.add : self.url.update;
                    self.isProcessing = true;

                    self.$http.post(url, self.vModel).then(
                        response => {
                            self.$toastr("success", "Saved Successfully");
                            self.$router.push(
                                "/" + self.url.redirect !== "" ?
                                self.url.redirect :
                                self.url.init
                            );
                            self.isProcessing = false;
                        },
                        error => {
                            self.isProcessing = false;
                        }
                    );
                }
            });
        },
        onCancel() {
            this.$router.push("/" + this.url.init);
            this.errors.clear();
        },
        logOut(e) {
            //alert();
            e.preventDefault();
            CommonService.logOut();
        },
        beforeSave() {
            return true;
        },
        setUrl: function () {
            return CommonService.getBaseUrl(this.url.list);
        },
        onCancelFilter() {
            if (kendo.ExternalFilter) delete kendo.ExternalFilter;

            this.refreshKendoDataSource();
        },
        onExternalFilterSubmit() {
            var self = this;

            self.$validator.validateAll("externalFilterForm").then(result => {
                if (result && this.beforeSave()) {
                    kendo.ExternalFilter = this.externalFilterViewModel;
                    this.refreshKendoDataSource();                    
                }
            });
        },
        refreshKendoDataSource: function () {
            if (this.kendoGrid !== null) {
                this.kendoGrid.dataSource.page(1);                
            }
        },
        onDataBound: function (ev) {
            this.kendoGrid = ev.sender;
            this.editButtons = document.body.querySelectorAll(".vue-kendo-link-edit");
            this.editButtons.forEach(el => {
                el.addEventListener("click", this.onEdit);
            });

            this.deleteButtons = document.body.querySelectorAll(
                ".vue-kendo-link-delete"
            );
            this.deleteButtons.forEach(el => {
                el.addEventListener("click", this.onDelete);
            });

        }
    }
};
</script>
